import { observer } from 'mobx-react-lite';
import { useLocation, useSearchParams } from 'react-router-dom';

import Modal from '~/components/Modal/Modal';
import { useModal } from '~/hooks/useModal';
import { useOnWarehouseChange } from '~/hooks/useOnWarehouseChange';
import { useStoreInstance } from '~/hooks/useStoreInstance';
import { ProductState } from '~/stores/CategoriesStore';
import { isProductBundle } from '~/types/Product';

import ProductModal from './components/ProductModal/ProductModal';
import Skeleton from './components/Skeleton/Skeleton';
import styles from './ModalProductDetails.module.scss';

interface ProductPageLocation {
  state: {
    source?: string;
    isDeeplink?: boolean;
    clean_filters?: boolean;
    offerSku?: string;
  };
}

const ModalProductDetails = () => {
  const [searchParams] = useSearchParams();
  const { state }: ProductPageLocation = useLocation();
  const productId = searchParams.get('productId');
  const sku = searchParams.get('sku');

  const product = useStoreInstance(ProductState, productId || '');
  const { closeModal } = useModal();

  useOnWarehouseChange(
    async (code) => {
      if (productId && !product.data && !product.request.isLoading) {
        await product.request.run({ productId, warehouse: code });

        if (state?.offerSku) {
          product.selectOffer(state.offerSku);
        }
      }
    },
    [productId, product],
  );

  const isBundle = product.data ? isProductBundle(product.data) : false;

  if (sku && !isBundle) {
    if (product.data?.offers.find((offer) => offer.sku === sku)) {
      product.selectOffer(sku);
    }
  }

  const handleCloseModal = () => {
    closeModal(['productId', 'sku']);
  };

  return (
    <Modal
      isShow={true}
      className={styles.details}
      onBackdropDismiss={handleCloseModal}
    >
      <div className={styles.details__container}>
        {!product.data || !product.selectedOffer ? (
          <Skeleton onClose={handleCloseModal} />
        ) : (
          <ProductModal productData={product} onClose={handleCloseModal} />
        )}
      </div>
    </Modal>
  );
};

export default observer(ModalProductDetails);
